import { jsx as r } from "react/jsx-runtime";
import { c as x } from "./clsx-OuTLNxxd.js";
const z = "_text_1tduc_29", s = {
  text: z,
  "is-small": "_is-small_1tduc_34",
  "is-uppercase": "_is-uppercase_1tduc_38",
  "is-ellipsis": "_is-ellipsis_1tduc_41",
  "is-center": "_is-center_1tduc_47",
  "color-primary": "_color-primary_1tduc_50",
  "color-secondary": "_color-secondary_1tduc_53",
  "color-tertiary": "_color-tertiary_1tduc_56",
  "color-eco-green": "_color-eco-green_1tduc_59",
  "color-success": "_color-success_1tduc_62",
  "color-error": "_color-error_1tduc_65",
  "color-inverted": "_color-inverted_1tduc_68",
  "color-warning": "_color-warning_1tduc_71",
  "color-highlight": "_color-highlight_1tduc_74",
  "color-inherit": "_color-inherit_1tduc_77",
  "is-bold": "_is-bold_1tduc_80",
  "size-xs": "_size-xs_1tduc_83",
  "size-sm": "_size-sm_1tduc_86",
  "size-base": "_size-base_1tduc_89",
  "size-lg": "_size-lg_1tduc_92",
  "size-xl": "_size-xl_1tduc_95",
  "dialog-overlay-show": "_dialog-overlay-show_1tduc_1",
  "dialog-content-show": "_dialog-content-show_1tduc_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1tduc_1"
};
function b({
  children: l,
  dangerouslySetInnerHTML: o,
  isSmall: d,
  isUppercase: a,
  ellipsis: u,
  isSpan: n,
  className: p = "",
  color: c = "primary",
  isBold: g,
  size: _,
  title: m,
  center: h,
  ...e
}) {
  const t = x(
    s.text,
    d && s["is-small"],
    u && s["is-ellipsis"],
    c && s[`color-${c}`],
    g && s["is-bold"],
    a && s["is-uppercase"],
    _ && s[`size-${_}`],
    h && s["is-center"],
    p
  ), i = n ? "span" : "div";
  return o ? /* @__PURE__ */ r(i, { className: t, dangerouslySetInnerHTML: o, ...e, title: m }) : /* @__PURE__ */ r(i, { className: t, ...e, children: l });
}
export {
  b as T,
  s
};
